export interface HealthPaletteItem {
  color: string;
  icon?: string;
  propagate?: boolean;
}

export type ServerHealthPaletteItem = HealthPaletteItem;

export const DEFAULT_HEALTH_PALETTE: Record<string, ServerHealthPaletteItem> = {
  diabetes: { color: '#ef4444', icon: '🩸', propagate: true },
  type_2_diabetes: { color: '#ef4444', icon: '🩸', propagate: true },
  hypertension: { color: '#f59e0b', icon: '❤️', propagate: true },
  depression: { color: '#6366f1', icon: '💧', propagate: false },
  cancer: { color: '#10b981', icon: '🎗️', propagate: true },
  heart_disease: { color: '#dc2626', icon: '💔', propagate: true },
  stroke: { color: '#9333ea', icon: '🧠', propagate: true },
  osteoporosis: { color: '#06b6d4', icon: '🦴', propagate: false },
  familial_hypercholesterolemia: { color: '#facc15', icon: '⚠️', propagate: true },
  brca2_mutation: { color: '#ec4899', icon: '🧬', propagate: true },
  hemophilia_a: { color: '#660000', icon: '🩸', propagate: true },
  hemophilia_a_carrier: { color: '#808080', icon: '🧬', propagate: true },
  autism: { color: '#ff69b4', icon: '🧩', propagate: false },
  down_syndrome: { color: '#8b5cf6', icon: '🧬', propagate: false },
  anemia: { color: '#ef4444', icon: '🩸', propagate: false },
  albinism: { color: '#e5e7eb', icon: '🌞', propagate: false },
  obesity: { color: '#a16207', icon: '⚖️', propagate: false },
};

export function mergeHealthPalette(
  diagramPalette: Record<string, ServerHealthPaletteItem> | undefined,
): Record<string, ServerHealthPaletteItem> {
  return { ...DEFAULT_HEALTH_PALETTE, ...(diagramPalette ?? {}) };
}
